import { useKlarna } from '@/customerFinanceOperations/Payment/components/PaymentMethods/Klarna/useKlarna';
import { Image } from '@/domains/core/Image/Image';
import { useApplePayIcons } from '@/domains/customerFinanceOperations/Payment/components/PaymentMethods/StandaloneApplePay/hooks/useApplePayIcons';

import Amex from './assets/amex.svg?url';
import ApplePay from './assets/apple-pay.svg?url';
import GooglePay from './assets/google-pay.svg?url';
import Klarna from './assets/klarna.svg?url';
import Mastercard from './assets/mastercard.svg?url';
import Paypal from './assets/paypal.svg?url';
import Visa from './assets/visa.svg?url';
import { ICON_HEIGHT, ICON_WIDTH } from './constants';

export const PaymentMeans = () => {
  const { showKlarna } = useKlarna();
  const showApplePay = useApplePayIcons();

  return (
    <div className={'mt-s inline-flex flex-wrap gap-s'}>
      <Image
        src={Visa}
        alt="Visa"
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
        data-testid="visa"
      />
      <Image
        src={Mastercard}
        alt="Mastercard"
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
        data-testid="mastercard"
      />
      {showKlarna && (
        <Image
          src={Klarna}
          alt="Klarna"
          width={ICON_WIDTH}
          height={ICON_HEIGHT}
          data-testid="klarna"
        />
      )}
      <Image
        src={Paypal}
        alt="Paypal"
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
        data-testid="paypal"
      />
      <Image
        src={Amex}
        alt="American Express"
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
        data-testid="american-express"
      />
      {showApplePay && (
        <Image
          src={ApplePay}
          alt="Apple Pay"
          width={ICON_WIDTH}
          height={ICON_HEIGHT}
          data-testid="apple-pay"
        />
      )}
      {!showApplePay && (
        <Image
          src={GooglePay}
          alt="Google Pay"
          width={ICON_WIDTH}
          height={ICON_HEIGHT}
          data-testid="google-pay"
        />
      )}
    </div>
  );
};

PaymentMeans.displayName = 'PaymentMeans';
